import React, {Component} from 'react'
import { connect } from 'react-redux'
import FaqItem from '../../../components/FaqItem'
import FaqPopin from '../../../components/FaqPopin'
import { fetchFaq } from './../../../services/ApiController'
import {FAQStyle, srOnlyStyle, FAQBottomStyles, ButtonStyle} from './../../../styles'
import { openModal} from './../../../store/actions/FaqModal'

class Faq extends Component {
  state = {
    activeTheme: 'all',
    activeItem: null,
    ready: false,
    popinOpen: false
  }

  changeTheme = (theme) => {
    this.setState({activeTheme: theme})
  }

  setActiveItem = (item) => {
    this.setState({activeItem: item})
  }

  getDatas = () => {
    fetchFaq().then((data) => {
        const nData = []
        let i = 0
        Object.keys(data).map((row, index) => {
          nData.push(data[row])
          i = index
          if (i === Object.keys(data).length - 1) this.setState({ FAQ: nData, ready: true })
        })

        this.setState({activeTheme: nData[0].filter(item => nData[1].map(item2 => item2.category).includes(item))[0]})
    }).catch((err) => {
      console.log('Something Wrong with FAQ data', err)
    })
  }

  componentDidMount() {
    this.getDatas()
  }

  render () {
    const FAQ = this.state.FAQ
    let allCategories = []

    // get all questions categories to remove categories with 0 question from nav
    if (FAQ) {
      allCategories = FAQ[1].map(item => item.category)
    }

    return (
      <div className={`faq pages-faq ${FAQStyle}`}>
        <h1 className={srOnlyStyle}>Q&A</h1>
        <div className="page-inner">
          <ul className="nav reset flex flex-wrap items-center">
            {
              FAQ && FAQ[0].filter(item => allCategories.includes(item)).map((item, index) => (
                <li key={index}>
                  <button onClick={() => this.changeTheme(item)} className={this.state.activeTheme === item ? 'active' : ''}>{item}</button>
                </li>
              ))
            }
          </ul>
        
          <div className="accordion">
            {
              FAQ && FAQ[1].map((item, index) => (
                <FaqItem 
                  key={index}
                  activeTheme={this.state.activeTheme}
                  themes={[item.category]} 
                  question={item.question}
                  activeItem={this.state.activeItem} 
                  setActiveItem={this.setActiveItem}
                  currentItem={index}
                  answer={item.answer} />
              ))
            }
          </div>

          <div className={FAQBottomStyles}>
            <p>This Q&A space is for participation purposes.<br/> If you do not find an answer to your question, please ask us using the button below.</p>

            <button onClick={() => this.props.openModal() } className={`btn ${ButtonStyle('red', true)}`}>Ask us your question</button>

            <FaqPopin />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  ({FaqModal}) => ({
    isOpen: FaqModal.isOpen
  }),
  dispatch => ({
    openModal: () => dispatch(openModal())
  })
)(Faq)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Faq.js